import { ARGOS_CARD_PROVIDED, PAYPAL_PROVIDED, KLARNA_PROVIDED } from './FinanceProviderConstants'

// Paypal pay in 3 not included
const PAYPAL_CREDIT_INTEREST_FREE = 'paypal_ifc'
const PAYPAL_CREDIT_INTEREST_BEARING = 'paypal_ibc'
const ARGOS_FINANCE_CARD = 'my_argos_card'
const KLARNA_FINANCE = 'klarna'

export const PROVIDER_MAP = {
  [PAYPAL_CREDIT_INTEREST_FREE]: PAYPAL_PROVIDED,
  [PAYPAL_CREDIT_INTEREST_BEARING]: PAYPAL_PROVIDED,
  [ARGOS_FINANCE_CARD]: ARGOS_CARD_PROVIDED,
  [KLARNA_FINANCE]: KLARNA_PROVIDED
}

export const getPreferredCreditPlans = creditPlan => {
  if (!creditPlan?.attributes?.eligibleProviders) {
    return {
      qualifyingCreditPlans: [],
      availableProviders: [ARGOS_CARD_PROVIDED]
    }
  }

  const { eligibleProviders } = creditPlan.attributes

  const qualifyingOffers = eligibleProviders.flatMap(provider => provider.qualifyingOfferings)

  // Get highest priority ArgosCard plan
  let highestPriorityArgosCardPlan = null
  const argosProvider = qualifyingOffers.find(provider => provider.id === ARGOS_FINANCE_CARD)
  if (
    argosProvider &&
    Array.isArray(argosProvider.qualifyingCreditPlans) &&
    argosProvider.qualifyingCreditPlans.length
  ) {
    const sortedPlans = [...argosProvider.qualifyingCreditPlans].sort((aSort, bSort) => aSort.priority - bSort.priority)
    highestPriorityArgosCardPlan = sortedPlans[0]
  }

  // Used to determine what should be displayed based on what providers are available for SKU and then sorted from [0] highest provider priority to lowest provider priority

  const providerPriorityMap = {}

  const availableProviders = qualifyingOffers
    .map(({ id, priority }) => {
      const key = PROVIDER_MAP[id]
      if (key) {
        providerPriorityMap[key] = priority ?? 999
      }
      return key
    })
    .filter(Boolean)
    .sort((aSort, bSort) => providerPriorityMap[aSort] - providerPriorityMap[bSort])

  // Used to get the Top 3 eligible credit plans - The top one is used in both PriceDynamicCreditCopy & FinanceProvider Custom widget - then all three or less are displayed is decending order within FinanceDrawer which is used in both PriceDynamicCreditCopy & FinanceProvider.
  let qualifyingCreditPlans = []
  qualifyingOffers
    .filter(provider => provider.id === PAYPAL_CREDIT_INTEREST_FREE || provider.id === PAYPAL_CREDIT_INTEREST_BEARING)
    .forEach(provider => {
      if (provider.qualifyingCreditPlans) {
        qualifyingCreditPlans = qualifyingCreditPlans.concat(provider.qualifyingCreditPlans)
      }
    })

  qualifyingCreditPlans.sort((APlan, BPlan) => APlan.priority - BPlan.priority)
  const topThreeCreditPlans = qualifyingCreditPlans.slice(0, 3)

  return {
    qualifyingCreditPlans: topThreeCreditPlans,
    availableProviders,
    highestPriorityArgosCardPlan
  }
}

// Updates the ANALYTICS_DATA_OBJECT with eligible credit plans.
export const updateCreditPlans = (productStoreData, ANALYTICS_DATA_OBJECT) => {
  if (!ANALYTICS_DATA_OBJECT.page.attributes.creditOffered) {
    // eslint-disable-next-line no-param-reassign
    ANALYTICS_DATA_OBJECT.page.attributes.creditOffered = []

    const qualifyingOffers =
      productStoreData?.creditPlans?.attributes?.eligibleProviders.flatMap(provider => provider.qualifyingOfferings) ||
      []

    const creditPlanMapping = {
      my_argos_card: 'argoscard',
      klarna: 'klarna',
      paypal_ifc: 'paypalIFC',
      paypal_ibc: 'paypalIBC'
    }

    qualifyingOffers.forEach(plan => {
      const creditType = creditPlanMapping[plan.id]
      if (creditType && !(creditType === 'argoscard' && productStoreData?.attributes?.partNumber.startsWith('tuc'))) {
        ANALYTICS_DATA_OBJECT.page.attributes.creditOffered.push(creditType)
      }
    })

    // // interest type is not a field in v5 or v6
    // const creditPlans = productStoreData.creditPlans?.attributes
    // if (creditPlans) {
    //   const mppOffered = creditPlans.find(plan => plan.interestType === 4)
    //   if (mppOffered) {
    //     ANALYTICS_DATA_OBJECT.page.attributes.creditOffered.push('MPP')
    //   }
    // }
  }
}
